import * as types from "./type.js";
export default {
  // 添加新的全局value
  [types.SET_VALUE](state, { name, value }) {
    state[name] = value;
  },
  // 设置预览文件
  setProjection(state, { fileurl, filename, mode, show }) {
    state.projection.fileurl = fileurl;
    state.projection.filename = filename;
    state.projection.mode = mode;
    state.projection.show = show;
  },
  // 设置预览文件
  setPreviewFiles(state, { fileurl, show }) {
    state.imagePreview.show = show;
    state.imagePreview.files = [fileurl];
  },
  // 设置ppt页码
  setPPTPage(state, { nowPage }) {
    state.pptInfo.nowPage = nowPage;
    state.pptInfo.show = true;
  },
  // 设置ppt文件
  setPPTFiles(state, { data, galleryid, nowPage, width, height, show = true }) {
    state.pptInfo.files = data;
    state.pptInfo.nowPage = nowPage;
    state.pptInfo.show = show;
    state.pptInfo.galleryid = galleryid;
    state.pptInfo.width = width;
    state.pptInfo.height = height;
  },
  // 结束ppt
  endPPTScreen(state) {
    state.pptInfo = {
      files: [],
      galleryid: "",
      show: false,
      nowPage: 0
    };
  },
  // 随堂提问-更新举手区名单
  setUpdateStudents(state, { userid, avatar, username }) {
    console.log("userid", state.raiseHandStudents);
    let sIndex = state.raiseHandStudents.findIndex(
      item => item.userid === userid
    );
    if (sIndex === 0) return false;
    if (sIndex !== -1) {
      state.raiseHandStudents.splice(sIndex, 1);
    }
    state.raiseHandStudents.unshift({ username, userid, avatar });
  },
  // 清空举手区
  clearRaiseStudents(state) {
    state.raiseHandStudents = [];
  },
  // 学生端上线
  setUpdateOnlineStudents(state, { username, userid }) {
    if (!username || !username) {
      state.studentsOnlines = [];
      return false;
    }
    let isOnline = state.studentsOnlines.some(item => item.userid === userid);
    if (isOnline) return false;
    state.studentsOnlines.push({ username, userid });
  },
  // 设置小程序端就是在线状态
  setTeacherOnline(state, status) {
    state.isTeacherOnline = status
  }
};
